<template>
  <v-chip class="my-1 ml-1 contractor-chip" :data-contractor="contractor_cd" small :color="chipColor">{{ contractorName }}</v-chip>
</template>

<script>
export default {
  mounted: function() {
  },
  watch: {
  },
  props: {
    contractor_cd:{
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {

    chipColor: function() {
      //if (this.contractor === "PS") {
      //  return "yellow"
      //}
      return ""
    },

    contractorName:function (){
      if (this.contractor_cd === "my1") return "森康"
      if (this.contractor_cd === "my2") return "エムワイ"
      if (this.contractor_cd === "my3") return "CMY"
      if (this.contractor_cd === "excel") return "エクセル"
      return this.contractor_cd + ""
    },

  },
  data() {
    return {
    }
  },
  methods: {

  }
}
</script>
